import { Brain } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-md bg-[#10B981]">
              <Brain className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-black">Xceltrain LLC</span>
          </div>
          <p className="text-sm text-gray-400" data-testid="copyright-notice">
            © 2026 Xceltrain LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};